import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Home, MapPin } from "lucide-react";
import MainLayout from "../layouts/MainLayout";

const NotFound = () => {
  const location = useLocation();

  return (
    <MainLayout>
    <div className="min-h-screen bg-parchment px-4 py-12 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="overflow-hidden rounded-[2.5rem] border border-brand-border/70 bg-card shadow-soft-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative hidden lg:block min-h-[560px]">
              <img
                src="https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=1400&q=80"
                alt="Đà Lạt"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-vintage-dark" />

              <div className="relative z-10 flex h-full flex-col justify-between p-10 text-white">
                <div>
                  <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm">
                    <MapPin size={24} />
                  </div>
                  <p className="mb-4 text-xs uppercase tracking-[0.28em] text-white/70">
                    Nelson Heritage
                  </p>
                  <h1 className="font-faustina text-6xl italic leading-[0.95] font-bold">
                    404
                    <br />
                    Not Found
                  </h1>
                  <p className="mt-6 max-w-md text-base leading-8 text-white/85">
                    Trang bạn truy cập không tồn tại hoặc đã được thay đổi.
                  </p>
                </div>

                <div className="rounded-[1.5rem] border border-white/15 bg-white/10 p-6 backdrop-blur-md">
                  <p className="text-sm leading-7 text-white/90">
                    Đường dẫn:{" "}
                    <span className="font-semibold text-white">
                      {location.pathname}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center">
              <div className="mx-auto w-full max-w-xl p-6 md:p-10 lg:p-14">
                <p className="mb-3 text-xs uppercase tracking-[0.24em] text-accent/70">
                  Oops
                </p>
                <h2 className="text-4xl font-bold text-text-main md:text-5xl">
                  Không tìm thấy trang
                </h2>
                <p className="mt-3 text-base leading-7 text-gray-500">
                  Bạn có thể quay lại trang chủ hoặc mở bản đồ để tiếp tục khám
                  phá.
                </p>

                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <Link
                    to="/"
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-nelson px-6 py-4 font-semibold text-white transition hover:bg-primary-hover"
                  >
                    <Home size={18} />
                    Về trang chủ
                  </Link>
                  <Link
                    to="/#home-hero"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-brand-border bg-[#fffdf8] px-6 py-4 font-semibold text-text-main shadow-soft transition hover:-translate-y-0.5 hover:shadow-soft-md"
                  >
                    <MapPin size={18} />
                    Mở bản đồ
                  </Link>
                </div>

                <div className="mt-6">
                  <Link
                    to="/"
                    onClick={(e) => {
                      // allow fallback for browsers without history API quirks
                      e.preventDefault();
                      window.history.length > 1 ? window.history.back() : (window.location.href = "/");
                    }}
                    className="inline-flex items-center gap-2 text-sm font-medium text-primary-hover hover:underline"
                  >
                    <ArrowLeft size={16} />
                    Quay lại
                  </Link>
                </div>

                <div className="mt-10 rounded-2xl border border-brand-border/70 bg-bg-section/55 px-5 py-4 text-sm text-text-soft">
                  <p className="font-semibold text-primary-hover mb-1">Gợi ý nhanh</p>
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Kiểm tra lại đường dẫn bạn nhập.</li>
                    <li>Mở bản đồ để xem toàn bộ địa điểm.</li>
                    <li>Thử truy cập từ menu trên đầu trang.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </MainLayout>
  );
};

export default NotFound;

